/* eslint-disable*/
import React, { Component } from "react";
import PropTypes from 'prop-types';
import { Button, Grid, Input } from "../../components";
import masks from "../../utils/masks";


class Periodo extends Component {
  constructor(props) {
    super(props);
  }
 
  render() {    
    return (
      <div className='row'>            
        <Grid cols="2 2 2 2">
          <Input 
            id={`dataInicio-${this.props.periodo.index}`}
            mask={masks.date}
            label="Data de Início"
            required
            disabled={this.props.disabledInputDate}
            value={this.props.state[`dataInicio-${this.props.periodo.index}`] ? this.props.state[`dataInicio-${this.props.periodo.index}`] : this.props.periodo[`dataInicio-${this.props.periodo.index}`]}
            onChange={e => this.props.changePeriodo(e, `dataInicio-${this.props.periodo.index}`)}
            onBlur={() => this.props.validarRegras()}  
          />
        </Grid>
        <Grid cols="2 2 2 2">
          <Input
            id={`dataFim-${this.props.periodo.index}`}
            mask={masks.date}
            label="Data de Fim"
            required
            disabled={this.props.disabledInputDate}
            value={this.props.state[`dataFim-${this.props.periodo.index}`] ? this.props.state[`dataFim-${this.props.periodo.index}`] : this.props.periodo[`dataFim-${this.props.periodo.index}`]}
            onChange={e => this.props.changePeriodo(e, `dataFim-${this.props.periodo.index}`)}
            onBlur={() => this.props.validarRegras()}      
          />
        </Grid>
        <Grid cols="1 1 1 1">
          <Input
            showMask={false}
            label="Anos"
            integer
            disabled
            value={this.props.periodo.totalAno}
          />
        </Grid>
        <Grid cols="1 1 1 1">
          <Input
            showMask={false}
            label="Meses"
            integer
            disabled
            value={this.props.periodo.totalMes}
          />
        </Grid>
        <Grid cols="1 1 1 1">
          <Input
            showMask={false}
            label="Dia"
            integer
            disabled
            value={this.props.periodo.totalDia}
          />
        </Grid>
        {this.props.periodo.index !== this.props.listaPeriodos.length-1 && this.props.displayButton &&
          <Grid cols="1 1 1 1">
            <Button
              className="ico-eraser"
              mini
              hint="Remover período"
              onClick={() => this.props.removerPeriodo(this.props.periodo.index)}
            />
          </Grid>
        } 
        {this.props.periodo.index === this.props.listaPeriodos.length-1 && this.props.displayButton &&
          <Grid cols="1 1 1 1">
            <Button
              className="ico-plus"
              mini
              hint="Adicionar período"
              disabled={this.props.verificarPreenchimentoPeriodos()}
              onClick={() => this.props.adicionarPeriodo()}
            />
          </Grid>
        }
      </div>
    )          
  } 
}

Periodo.propTypes = { 
  state:PropTypes.objectOf(PropTypes.object).isRequired, 
  periodo: PropTypes.objectOf(PropTypes.object).isRequired,
  listaPeriodos: PropTypes.arrayOf({
    index: PropTypes.number,
    dataInicio: PropTypes.string,
    dataFim: PropTypes.string,
    totalAno: PropTypes.number,
    totalMes: PropTypes.number,
    totalDia: PropTypes.number,
    diasCorridos: PropTypes.number,
}).isRequired,
  displayButton: PropTypes.bool.isRequired,
  disabledInputDate: PropTypes.bool.isRequired,
  changePeriodo: PropTypes.func.isRequired,
  validarRegras: PropTypes.func.isRequired,
  verificarPreenchimentoPeriodos:  PropTypes.func.isRequired,
  adicionarPeriodo: PropTypes.func.isRequired,
  removerPeriodo: PropTypes.func.isRequired,
};

export default Periodo;


// WEBPACK FOOTER //
// ./src/pages/calculadora-periodos/Periodo.jsx